module.exports = __webpack_public_path__ + "img/solution33.e00bc3a8.png";